import type { EventDetailPersonLink, EventDetailSpeakerLinkKind } from '../types/event-detail'

export const speakerLinkKind = (link: EventDetailPersonLink): EventDetailSpeakerLinkKind => {
  const url = link.url.toLowerCase()
  const title = link.title.toLowerCase()
  if (url.includes('linkedin.') || title.includes('linkedin')) return 'linkedin'
  if (url.includes('twitter.com') || url.includes('://x.com') || url.includes('.x.com') || title === 'x' || title.includes('twitter'))
    return 'x'
  if (url.includes('instagram.') || title.includes('instagram')) return 'instagram'
  if (url.includes('youtube.') || url.includes('youtu.be') || title.includes('youtube')) return 'youtube'
  return 'website'
}

export const speakerLinkLabel = (link: EventDetailPersonLink): string => {
  if (speakerLinkKind(link) !== 'website') return link.title
  try {
    return new URL(link.url).hostname.replace(/^www\./, '')
  } catch {
    return link.title
  }
}
